import { render, staticRenderFns } from "./FormTemplates.vue?vue&type=template&id=5b12c456"
import script from "./FormTemplates.vue?vue&type=script&lang=js"
export * from "./FormTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports